import script from "./Game.vue?vue&type=script&setup=true&lang=js"
export * from "./Game.vue?vue&type=script&setup=true&lang=js"

import "./Game.vue?vue&type=style&index=0&id=c299d624&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c299d624"]])

export default __exports__